
import { defineComponent, computed, watch, onMounted } from 'vue';
import { usePageStore } from '@/store/pagenation'
import { useRoute } from 'vue-router'

export default defineComponent({
  setup() {
    const pageStore = usePageStore();
    const route = useRoute()
    const totalPage = computed(() => pageStore.getTotalPage);
    const currPage = computed(() => pageStore.getCurrPage);

    const pageGroupSize = computed(() => pageStore.getPageGroupSize);

    const startPage = computed(() => Math.floor((currPage.value - 1) / pageGroupSize.value) * pageGroupSize.value + 1);
    const endPage = computed(() => Math.min(startPage.value + pageGroupSize.value - 1, totalPage.value));

    const visiblePages = computed(() => {
      const pages: number[] = [];
      for (let i = startPage.value; i <= endPage.value; i++) pages.push(i);
      return pages;
    });

    const movePage = (idx: number) => {
      if (idx < 1) idx = 1;
      if (idx > totalPage.value) idx = totalPage.value;
      pageStore.setCurrPage(idx);
    }

    const setPage = (path: string) => {
      if(path.includes('info')) {
        usePageStore().setPageGroupSize(4);
      } else {
        usePageStore().setPageGroupSize(10);
        movePage(1);
      }
    }

    watch(() => route.fullPath, (newPath, oldPath) => {
      setPage(newPath)
    });

    onMounted(() => {
      setPage(route.fullPath)
    })

    return { currPage, totalPage, startPage, endPage, visiblePages, movePage };
  }
});
